module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kate Locke\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Kate Locke")]), _vm._v(" is a shameless anglophile who wrote her first book at age twelve. Fortunately, that book about a British pop band is lost forever. During 'off' hours Kate spends time caressing her collection of Fluevogs, watches BBC America, or plays with makeup. She loves history, the paranormal, horror, and sparkly things.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1C9l2vt/tc-custom/9780316202350.jpg?1742009991280",
      "alt": "This image is the cover for the book God Save the Queen, The Immortal Empire"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("God Save the Queen, The Immortal Empire\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("London belongs to vampires, werewolves and goblins—and Queen Victoria rules with an immortal fist—in this fantasy series debut.")]), _c('br'), _c('br'), _vm._v("The undead matriarch presides over a Britain where the Aristocracy is made up of werewolves and vampires, where goblins live underground and mothers know better than to let their children out after dark. It's a world where the nobility are infected with the Plague (side-effects include undeath), Hysteria is the popular affliction of the day, and leeches are considered a delicacy. And a world where technology lives side by side with magic. The year is 2012 and Pax Britannia still reigns."), _c('br'), _c('br'), _vm._v("Xandra Vardan is a member of the elite Royal Guard, and it is her duty to protect the Aristocracy. But when her sister goes missing, Xandra will set out on a path that undermines everything she believed in and uncover a conspiracy that threatens to topple the empire. And she is the key—the prize—in a very dangerous struggle."), _c('br'), _c('br'), _vm._v("The fantastic start to The Immortal Empire series that continues with the spectacular undead books, "), _c('i', [_vm._v("The Queen is Dead")]), _vm._v(" and "), _c('i', [_vm._v("Long Live the Queen")]), _vm._v(".")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Orbit\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0